import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';
import { Product } from '@shared/components/ui/Product';

export interface ProductRowData {
  id: string;
  name: string;
  code: string;
  image: string;
  expectedQuantity: number;
  processedQuantity: number;
  isCompleted: boolean;
}

export interface ProductRowProps {
  product: ProductRowData;
  onLocationClick: (product: ProductRowData) => void | Promise<void>;
  showSeparator?: boolean;
  dataTestIdPrefix?: string;
}

export const ProductRow = ({
  product,
  onLocationClick,
  showSeparator = false,
  dataTestIdPrefix = 'product',
}: ProductRowProps) => {
  return (
    <div>
      <div className="flex items-center justify-between py-2 flex-col sm:flex-row gap-3">
        {/* Lado izquierdo - Información del producto */}
        <div className="flex items-center gap-3 flex-1 border-b border-card-border pb-2 sm:border-b-0 sm:pb-0 w-full sm:w-auto">
          <Product
            id={parseInt(product.id)}
            name={product.name}
            src={product.image}
            code={product.code}
            showTooltip={true}
            enableLineClamp={false}
            data-testid={`${dataTestIdPrefix}-${product.id}`}
          />
        </div>

        {/* Lado derecho - Cantidad y ubicación */}
        <div className="flex items-center gap-3 w-full sm:w-auto justify-between">
          {/* Cantidad */}
          <div className="flex items-center gap-2 bg-card-border rounded-full px-3 py-0.5 h-6">
            <span className="text-xs font-medium text-title">
              {product.processedQuantity} / {product.expectedQuantity}
            </span>
            <div className="h-3 w-3 leading-none relative">
              {product.isCompleted ? (
                <FontAwesomeIcon icon={faCheckCircle} className="w-3 h-3 text-success top-0 absolute" />
              ) : (
                <div className="rounded-full border border-icons flex items-center justify-center w-3 h-3 bg-transparent"></div>
              )}
            </div>
          </div>

          {/* Icono de ubicación */}
          <div className="flex items-center gap-2 bg-card-border rounded-full px-1 py-0 h-6">
            <Button
              variant="ghost"
              size="sm"
              onClick={async () => await onLocationClick(product)}
              className="p-2 hover:bg-transparent"
              data-testid={`location-button-${product.id}`}
            >
              <FontAwesomeIcon icon={faLocationDot} className="!w-3 !h-3 text-icons" />
            </Button>
          </div>
        </div>
      </div>

      {/* Separador */}
      {showSeparator && <div className="border-t border-lines"></div>}
    </div>
  );
};
